import type { FormInstance } from '@arco-design/web-react/es/Form';

import type { ModelInstanceFormValues } from '@/delivery-type-plugin/capabilities/maas-model-storage/modelInstanceTypes';

import { InferenceFrameworkSetting } from './inference-framework-setting';

export interface MaasSystemConfigSectionProps {
  form: FormInstance;
  isEdit?: boolean;
  initValues?: ModelInstanceFormValues;
  presetArchitecture?: string;
  presetImageLocked?: boolean;
  lockActionsWhenFilled?: boolean;
  /** 仅展示自定义镜像地址，隐藏推理框架来源选择。 */
  customImageOnly?: boolean;
}

/** 系统配置：推理框架 / 镜像（模型加载路径在「模型与存储」） */
export function MaasSystemConfigSection({
  form,
  isEdit,
  initValues,
  presetArchitecture,
  presetImageLocked,
  lockActionsWhenFilled,
  customImageOnly,
}: MaasSystemConfigSectionProps) {
  return (
    <InferenceFrameworkSetting
      form={form}
      compact
      isEdit={isEdit}
      initValues={initValues}
      presetArchitecture={presetArchitecture}
      presetImageLocked={presetImageLocked}
      lockActionsWhenFilled={lockActionsWhenFilled}
      customImageOnly={customImageOnly}
    />
  );
}
